import { css, type Theme } from "@emotion/react";

export const link = css`
  white-space: nowrap;
`;

export const appColor = (theme: Theme) => css`
  color: ${theme.success.textBase};
`;
